import { render, staticRenderFns } from "./tvshows.vue?vue&type=template&id=04d673e2&scoped=true&"
import script from "./tvshows.vue?vue&type=script&lang=js&"
export * from "./tvshows.vue?vue&type=script&lang=js&"
import style0 from "./tvshows.vue?vue&type=style&index=0&id=04d673e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d673e2",
  null
  
)

export default component.exports